import { BenefitTypes, Organization, ProductContent } from '../global';
import { TravellerType, TripInformation } from '../quote';

export const CLEAR_RECOMMENDATION = 'CLEAR_RECOMMENDATION';
export const SET_DOB_ERROR = 'SET_DOB_ERROR';
export const RECOMMENDATION_REQUEST_START = 'RECOMMENDATION_REQUEST_START';
export const RECOMMENDATION_REQUEST_SUCCESS = 'RECOMMENDATION_REQUEST_SUCCESS';
export const RECOMMENDATION_REQUEST_FAILED = 'RECOMMENDATION_REQUEST_FAILED';
export const RECOMMENDATION_CONTENT_START = 'RECOMMENDATION_CONTENT_START';
export const RECOMMENDATION_CONTENT_SUCCESS = 'RECOMMENDATION_CONTENT_SUCCESS';
export const RECOMMENDATION_CONTENT_FAILED = 'RECOMMENDATION_CONTENT_FAILED';
export const RECOMMENDATION_INDIVIDUAL_REQUEST_START = 'RECOMMENDATION_INDIVIDUAL_REQUEST_START';
export const RECOMMENDATION_INDIVIDUAL_REQUEST_SUCCESS = 'RECOMMENDATION_INDIVIDUAL_REQUEST_SUCCESS';
export const RECOMMENDATION_INDIVIDUAL_REQUEST_FAILED = 'RECOMMENDATION_INDIVIDUAL_REQUEST_FAILED';
export const RECOMMENDATION_CONFIG_START = 'RECOMMENDATION_CONFIG_START';
export const RECOMMENDATION_CONFIG_SUCCESS = 'RECOMMENDATION_CONFIG_SUCCESS';
export const RECOMMENDATION_CONFIG_FAILED = 'RECOMMENDATION_CONFIG_FAILED';

export interface Benefit {
  code: string;
  benefitType: BenefitTypes;
  purchasable: boolean;
  cancellable: boolean;
  adjustments?: {
    code: string;
  }[];
  hasError?: boolean;
}

export interface BenefitConfigRule {
  type: BenefitConfigRuleType;
  isPreDepartureIncreaseAllowed: boolean;
  isPostDepartureIncreaseAllowed: boolean;
  isPreDepartureDecreaseAllowed: boolean;
  isPostDepartureDecreaseAllowed: boolean;
}

export enum BenefitConfigRuleType {
  TRIP_COST = 'TRIPCOST',
  DEDUCTIBLE = 'DEDUCTIBLE',
  COVERAGEAMOUNT = 'COVERAGEAMOUNT',
  TRIP_DURATION = 'TRIPDURATION'
}

export interface RecommendationPlanResponse {
  code: string;
  organizationCode: string;
  isMQNeeded: boolean;
  benefits: Benefit[];
  tripType: string;
  travellerType: string | string[];
  currency: string;
  isAllBenefitsError?: boolean;
}

export interface RecommendationResponsePayload {
  referenceNumber?: string;
  plans?: RecommendationPlanResponse[];
}

export interface RecommendationStoreResponse {
  recommendationData?: RecommendationResponsePayload;
  error?: unknown;
  loading?: boolean;
  referenceNumber?: string;
  isAllPlansError?: boolean;
}

export interface RecommendationPayload {
  language: string;
  agentKey: string;
  travellerType: TravellerType;
  travellerCategory?: string;
  applicationDate: string;
  createdAt?: string;
  tripInformation: TripInformation;
  paxes: {
    referenceNumber: string;
    age?: number;
    dateOfBirth?: string;
    tripBookingDate?: string;
  }[];
  dependents: {
    referenceNumber: string;
    age?: number;
    dateOfBirth?: string;
    tripCost?: number;
  }[];
}
export interface ApiErrorDetails {
  message?: string;
  errorCode?: string;
  errorRef?: string;
}
export interface RecommendationState {
  [props: number]: RecommendationStoreResponse;
  dobError?: { [props: number]: string };
  dobFocus?: { [props: number]: boolean };
  recommendationFetched?: boolean;
  recommendationError?: boolean;
  recommendationServerError?: boolean;
  apiError?: ApiErrorDetails;
  productContents?: ProductContent[];
  orgContent?: Organization;
  contentFetched?: boolean;
  contentError?: unknown;
  contentServerError?: boolean;
  configFetched?: boolean;
  configError?: unknown;
  configServerError?: boolean;
}

export interface TripCost {
  eligible?: boolean;
  maxValue?: number;
  minValue?: number;
}

export interface TripDurationByAges {
  maxAgeUnit: number;
  maxAgeUnitType: string;
  maxDurationUnit: number;
  maxDurationUnitType: string;
  minAgeUnit: number;
  minAgeUnitType: string;
  minDurationUnit: number;
  minDurationUnitType: string;
}

export interface TripDuration {
  maxTripDurationUnit: number;
  maxTripDurationUnitType: string;
  minTripDurationUnit: number;
  minTripDurationUnitType: string;
}

export interface ProductConfig {
  tripDurationByAges: TripDurationByAges[];
  tripDurations: TripDuration[];
}

export interface ProductBenefitConfig {
  code: string;
  rules: BenefitConfigRule[];
  isPostDepartureDurationDecreaseAllowed: boolean;
  isPreDepartureDurationDecreaseAllowed: boolean;
  planCancellableAfterFreeLook: boolean;
}

export type ProductConfigDuration = TripDurationByAges | TripDuration;
export enum EligibilityOptsType {
  TRIP_COST = 'TRIPCOST'
}
